import { useState, useEffect } from 'react'
import { marked } from 'marked'

const csrf = () => document.querySelector('meta[name="csrf-token"]')?.content || ''

export default function DocsPanel() {
  const [list, setList] = useState([])
  const [name, setName] = useState(null)
  const [content, setContent] = useState('')
  const [editing, setEditing] = useState(false)
  const [status, setStatus] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetch('/cruz/dev/docs', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then((r) => r.json())
      .then((d) => {
        setList(d)
        if (d.length) open(d[0].name)
      })
      .catch(() => setStatus('一覧の取得に失敗しました'))
      .finally(() => setLoading(false))
  }, [])

  function open(n) {
    setEditing(false)
    setStatus('')
    fetch(`/cruz/dev/docs/${n}`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then((r) => r.json())
      .then((d) => {
        setName(n)
        setContent(d.content || '')
      })
      .catch(() => setStatus('読み込みに失敗しました'))
  }

  function save() {
    setStatus('保存中…')
    fetch(`/cruz/dev/docs/${name}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrf(),
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({ content }),
    })
      .then((r) => {
        if (!r.ok) throw new Error()
        return r.json()
      })
      .then(() => {
        setStatus('保存しました ✓')
        setEditing(false)
      })
      .catch(() => setStatus('保存に失敗しました'))
  }

  if (loading) return <p className="dj-cruz__empty">読み込み中…</p>
  if (!list.length) return <p className="dj-cruz__empty">docs/ に .md がありません</p>

  return (
    <div className="dj-docs">
      <div className="dj-docs__tabs">
        {list.map((d) => (
          <button
            key={d.name}
            type="button"
            className={'dj-docs__tab' + (d.name === name ? ' dj-docs__tab--on' : '')}
            onClick={() => open(d.name)}
          >
            {d.name}
          </button>
        ))}
      </div>

      {name && (
        <div className="dj-docs__main">
          <div className="dj-docs__bar">
            <button type="button" className="dj-btn dj-btn--ghost dj-btn--sm" onClick={() => setEditing((e) => !e)}>
              {editing ? '閲覧に戻る' : '編集'}
            </button>
            {editing && (
              <button type="button" className="dj-btn dj-btn--primary dj-btn--sm" onClick={save}>
                保存
              </button>
            )}
            <span className="dj-docs__status">{status}</span>
          </div>

          {editing ? (
            <textarea
              className="dj-docs__editor"
              value={content}
              onChange={(e) => setContent(e.target.value)}
              spellCheck={false}
            />
          ) : (
            <div className="dj-docs__view" dangerouslySetInnerHTML={{ __html: marked.parse(content || '') }} />
          )}
        </div>
      )}
    </div>
  )
}
